import {LOCALE_ID, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {HttpClientModule} from '@angular/common/http';
import {ComponentsModule} from "./components/components.module";
import {IonicSelectableModule} from "ionic-selectable";
import {PipesModule} from "./pipes/pipes.module";
import es from '@angular/common/locales/es-VE';
import {DatePipe, registerLocaleData} from '@angular/common';
//import { FileChooser } from '@ionic-native/file-chooser/ngx';
//import { FilePath } from '@ionic-native/file-path/ngx';
//import { Camera } from '@ionic-native/camera/ngx';

registerLocaleData(es);
@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    ComponentsModule,
    IonicSelectableModule,
    PipesModule
  ],
  providers: [DatePipe,
    StatusBar,
    SplashScreen,//, FileChooser, FilePath,Camera,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {provide: LOCALE_ID, useValue: 'es-VE' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
